import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getBase64 } from "../../utils/utils";
import * as APIS from "../../utils/service";
import { close, loadingflas, open } from "../../redux/popupSlice";
import { useSelector } from "react-redux";
import Button from "../../component/Button";

export default function ReportPop(props) {
    const {
        boardInfo,
        onClose = () => { }
    } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectFile = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);

    const [termlist, setconfigs] = useState(configdata?.consts?.reportselData);

    const [popcomments, setpopcomments] = useState(`게시판(소모임)명: ${boardInfo?.board}
게시글 번호: ${boardInfo?.idx}${boardInfo?.commentInfo ? "\n댓글내용:" + boardInfo?.commentInfo?.desc : ""}
자세한내용은 아래에 입력해주세요.

`);
    const [errmsg, seterrmsg] = useState('');
    const [title, settitle] = useState('');
    const [files, setfiles] = useState([]);

    const reportSubmit = () => {
        if (title === '') {
            seterrmsg('신고사유를 선택해주세요.');
            return;
        }
        if (popcomments === '') {
            seterrmsg('신고내용을 입력해주세요.');
            return;
        }

        let fileSetting = [];
        files?.map((x, i) => {
            //console.log(x);
            fileSetting.push({ base: x?.base64, ext: x?.ext });
        });
        //return;
        let sender = {
            u_idx: boardInfo?.userId,
            target_idx: boardInfo?.targetId,
            title: title,
            desc: popcomments,
            files: fileSetting
        }
        dispatch(loadingflas({ loading: true }));

        APIS.postData('/v1/mediation/reportinsert', sender).then(({ data }) => {
            if (data) {
                onClose();
            }
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: data?.msg,
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                    button: "확인",
                    onPress: () => {
                        dispatch(close());
                    }
                })
            );

        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    return <div className='PopupArea'>
        <div>
            <div className='PopupAreaBG'
            />
            <div className='PopupAreaContents' style={{ width: 600 }}>
                <div>
                    <div className="popTitle padding20">
                        <span >신고하기</span>
                        <button
                            onClick={() => {
                                onClose();
                            }}
                        >
                            <img src="./images/icons/x.svg" width='20' />
                        </button>
                    </div>
                    <div className="padding32">
                        <div className='popcontents'>
                            <div style={{ width: '100%' }}>
                                <div>
                                    신고 사유를 선택해주세요.
                                </div>
                                <div style={{ fontWeight: 700, marginTop: 20 }}>
                                    신고 사유<span style={{ color: 'red' }}>*</span>
                                </div>
                                <div>
                                    {termlist?.map((x, i) => {
                                        return (
                                            <div key={i} className='register_checks' style={{ marginTop: 5 }}>
                                                <button type="button"
                                                    onClick={() => {
                                                        settitle(x?.title);
                                                    }}>
                                                    <img src={`./images/icons/BGM_${title === x?.title ? '' : 'un'}check.svg`} style={{ width: 24, height: 24 }} />
                                                    <div>{x?.title}</div>
                                                </button>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div style={{ fontWeight: 700, marginTop: 20 }}>
                                    신고 내용<span style={{ fontWeight: 400, color: '#333' }}>(500자 이하 상세하게 작성해 주세요.)</span><span style={{ color: 'red' }}>*</span>
                                </div>
                                <div style={{ width: '100%', marginTop: 10 }}>
                                    <textarea
                                        onChange={(e) => {
                                            setpopcomments(e.target.value);
                                        }}
                                        placeholder='내용을 입력해 주세요. (500자 이하)'
                                        style={{
                                            width: '100%', height: 200, padding: 12,
                                            borderRadius: 4, border: '1px solid #DDD'
                                        }}
                                    >{popcomments}</textarea>
                                </div>

                                <div className='normalform_comment' style={{ fontWeight: 700, marginTop: 20 }}>
                                    관련 이미지<span style={{ fontWeight: 400, color: '#333' }}>(1장 이상)</span>
                                </div>
                                <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                                    let file = e.target.files[0];
                                    getBase64(file).then(result => {
                                        file["base64"] = result;
                                        file["ext"] = file.name.split('.')[1];
                                        //console.log("File Is", file);
                                        //setfiles([...files, file]);
                                        let filesdata = [];
                                        filesdata.push(file);
                                        setfiles(filesdata);
                                        setfiles(files.concat(filesdata));
                                    })
                                        .catch(err => { console.log(err); });
                                }} />

                                <div className="write_image_list">
                                    {files?.length < 3 &&
                                        <button
                                            type="button"
                                            onClick={() => {
                                                selectFile.current.click();
                                            }}
                                        >
                                            <p>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z" fill="#6164A5" />
                                                </svg>
                                            </p>
                                            <p>{files?.length}<span className='color999'>/3</span></p>
                                        </button>}
                                    {files?.map((x, i) => {
                                        return (
                                            <div key={i} style={{ backgroundImage: `url(${x?.base64})` }}>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setfiles(files?.filter((x2, i2) => i2 !== i));
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                        <rect x="0.333984" width="16" height="16" rx="4" fill="#101010" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white" />
                                                    </svg>
                                                </button>
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>
                        </div>
                        {errmsg &&
                            <div className='input_error ' style={{ width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                {errmsg}
                            </div>}

                        <div className='popbuttons'>
                            <div style={{ width: '100%' }}>
                                <Button
                                    buttonTxt={'신고하기'}
                                    onPress={() => {
                                        dispatch(
                                            open({
                                                component: '신고하시겠습니까?',
                                                title: '신고하기',
                                                button: "신고",
                                                buttonCencle: "취소",
                                                titleviewer: true,
                                                alert: false,
                                                onPress: () => {
                                                    reportSubmit();
                                                    dispatch(close());
                                                },
                                                onCancelPress: () => {
                                                    dispatch(close());
                                                }
                                            })
                                        );


                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
}